import React, { useEffect, useRef } from 'react';

import classNames from 'classnames';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { faTableLayout } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import Tooltip from 'components/tooltip';

interface Props {
  className?: string;
  children: React.ReactNode;
  hide?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}

// NOTE: Mostly copied from an existing, old component - don't use this as an example of best practices
export default function ColumnSelectorButton({ className, children, hide, onOpen, onClose }: Props) {
  const overlayRef = useRef<any>(null);

  useEffect(() => {
    if (hide) {
      overlayRef.current.hide();
    }
  }, [hide]);

  return (
    <div className={classNames('clickable', className)}>
      <OverlayTrigger
        overlay={<Popover id="popover-positioned-bottom">{children}</Popover>}
        placement="bottom"
        ref={overlayRef}
        rootClose
        trigger="click"
        onEnter={onOpen}
        onExit={onClose}
      >
        <Tooltip content="Manage columns">
          <Button.Secondary className="column-selector-button" icon={faTableLayout} outlined />
        </Tooltip>
      </OverlayTrigger>
    </div>
  );
}
